import lang from '../../lib/language';

export const WEEK52_GAINERS_AND_LOSERS_SYMBOL_NAME_LIMIT = 14;
export const WEEK52_GAINERS_AND_LOSERS_SYMBOL_NAME_MOB_LIMIT = 10;
export const WEEK52_GAINERS_AND_LOSERS_TABLE_HEADERS = [
  lang.commonEpicMoversSymbolName(),
  lang.commonLastPrice(),
  lang.commonEpicMoversDaily52Wk(),
];

export const WEEK52_HIGH_LOW_HEADERS_MOBILE = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonLastPriceShort(),
  lang.commonDiscover52WeekPercentChangeMobile(),
];
